<!--
 * @Author: your name
 * @Date: 2021-05-01 16:49:40
 * @LastEditTime: 2021-05-01 23:07:52
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \shangxin\szx\zx_metting\src\components\index.vue
-->
<template>
  <div class="home">
    <div class="home-info">
      <div class="home-info-detail">
        <!-- 标语 -->
        <div class="slogan container" v-if="bodyContent.position0&&bodyContent.position0.infoData.length > 0">
          <h3 @click="detailHandle(bodyContent.position0['infoData'][0]['strId'])">
            {{ bodyContent.position0['infoData'][0]['strMasTitle'] }}
          </h3>
          <div class="row">
            <p v-html="bodyContent.position0['infoData'][0]['strText']"></p>
            <i @click="detailHandle(bodyContent.position0['infoData'][0]['strId'])"
              >【详情】</i
            >
          </div>
        </div>
        <div class="list-swiper container">
          <div
            class="list list-wrap"
            v-if="bodyContent.position1&&bodyContent.position1.infoData.length > 0"
            data-title="会议要闻"
          >
            <ul>
              <li
                v-for="(item, index) in bodyContent.position1.infoData"
                :key="index"
                @click="detailHandle(item.strId)"
              >
                {{ item.strMasTitle }}
              </li>
            </ul>
          </div>
          <Swiper
            :swiperArr="bodyContent.position2.infoData"
            v-if="bodyContent.position2&&bodyContent.position2.infoData.length > 0"
          ></Swiper>
        </div>
        <div class="schedule-work container">
          <Schedule data-title="两会日程"></Schedule>
          <div
            class="work list-wrap"
            v-if="bodyContent.position3&&bodyContent.position3.infoData.length > 0"
            data-title="工作综述 4"
          >
            <div class="title">
              <span @click="navHandle(bodyContent.position3.strId)">更多+</span>
            </div>
            <ul>
              <li
                v-for="(item, index) in bodyContent.position3.infoData"
                :key="index"
                @click="detailHandle(item.strId)"
              >
                {{ item.strMasTitle }}
              </li>
            </ul>
          </div>
        </div>
        <div class="statement-list container">
          <img class="title" src="../assets/images/statement.jpg" alt="" />
          <div class="row">
            <Statement
              :swiperArr="bodyContent.position4.infoData"
              v-if="bodyContent.position4&&bodyContent.position4.infoData.length > 0"
              data-title="左侧滚动发言"
            ></Statement>
            <div
              class="list list-wrap"
              v-if="bodyContent.position5&&bodyContent.position5.infoData.length > 0"
              data-title="右侧发言"
            >
              <ul>
                <li
                  v-for="(item, index) in bodyContent.position5.infoData"
                  :key="index"
                >
                  <div class="item" v-if="index == 0">
                    <h5 @click="detailHandle(item.strId)">
                      {{ item.strMasTitle }}
                    </h5>
                    <div class="item-row">
                      <p v-html="item.strText.slice(0, 48)"></p>
                      <i @click="detailHandle(item.strId)">【详情】</i>
                    </div>
                  </div>
                  <span v-else @click="detailHandle(item.strId)">{{
                    item.strMasTitle
                  }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="video-committee container">
          <div class="video" v-if="webPositionData[6]" data-title="视频新闻">
            <div class="title">
              <img src="../assets/images/video.jpg" alt="" />
            </div>
            <Swiper
              :swiperArr="webPositionData[6]['infoData']"
              style="height: 445px"
            ></Swiper>
          </div>
          <div
            class="committee list-wrap"
            v-if="webPositionData[7]"
            data-title="委员风采 7"
          >
            <div class="title">
              <img src="../assets/images/committee.jpg" alt="" />
            </div>
            <ul>
              <li
                v-for="(item, index) in webPositionData[7]['infoData']"
                :key="index"
                @click="detailHandle(item.strId)"
              >
                {{ item.strMasTitle }}
              </li>
            </ul>
          </div>
        </div>
        <div class="report container" v-if="webPositionData[8]" data-title="8 ">
          <div class="title">
            <img src="../assets/images/report.jpg" alt="" />
          </div>
          <ul>
            <li
              @click="detailHandle(webPositionData[8]['infoData'][0]['strId'])"
            >
              <p>{{ webPositionData[8]['strName'] }}</p>
            </li>
            <li @click="linkHandle(webPositionData[9]['infoData'][0])">
              <p>{{ webPositionData[9]['strName'] }}</p>
            </li>
          </ul>
        </div>
        <div
          class="meeting-place container"
          v-if="webPositionData[10]"
          data-title="10 会场内外"
        >
          <div class="title">
            <img src="../assets/images/place.png" alt="" />
          </div>
          <div class="row">
            <div class="item" data-index="0,1">
              <div
                class="info"
                @click="
                  detailHandle(webPositionData[10]['infoData'][0]['strId'])
                "
              >
                <img
                  :src="webPositionData[10]['infoData'][0]['strPicPath']"
                  alt=""
                />
                <p>
                  {{ webPositionData[10]['infoData'][0]['strMasTitle'] }}
                </p>
              </div>
              <div
                class="info"
                @click="
                  detailHandle(webPositionData[10]['infoData'][1]['strId'])
                "
              >
                <img
                  :src="webPositionData[10]['infoData'][1]['strPicPath']"
                  alt=""
                />
                <p>
                  {{ webPositionData[10]['infoData'][1]['strMasTitle'] }}
                </p>
              </div>
            </div>
            <div class="item" data-index="4">
              <div
                class="info"
                @click="
                  detailHandle(webPositionData[10]['infoData'][4]['strId'])
                "
              >
                <img
                  :src="webPositionData[10]['infoData'][4]['strPicPath']"
                  alt=""
                />
                <p>
                  {{ webPositionData[10]['infoData'][4]['strMasTitle'] }}
                </p>
              </div>
            </div>
            <div class="item" data-index="2,3">
              <div
                class="info"
                @click="
                  detailHandle(webPositionData[10]['infoData'][2]['strId'])
                "
              >
                <img
                  :src="webPositionData[10]['infoData'][2]['strPicPath']"
                  alt=""
                />
                <p>
                  {{ webPositionData[10]['infoData'][2]['strMasTitle'] }}
                </p>
              </div>
              <div
                class="info"
                @click="
                  detailHandle(webPositionData[10]['infoData'][3]['strId'])
                "
              >
                <img
                  :src="webPositionData[10]['infoData'][3]['strPicPath']"
                  alt=""
                />
                <p>
                  {{ webPositionData[10]['infoData'][3]['strMasTitle'] }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from '@/components/base/swiper.vue'
import Schedule from '@/components/base/schedule.vue'
import Statement from '@/components/base/statement.vue'
import 'swiper/css/swiper.min.css'
import {
  infoData,
  navigationForZx,
  homeData,
  bodyData
} from '@/api/configuration'
import { get } from '../utils/helpers'

export default {
  name: 'Home',
  components: {
    Swiper,
    Schedule,
    Statement
  },
  data() {
    return {
      bodyContent:{},// 首页数据
      webPositionData: [], // 首页数据
      swiperInfo: [
        {
          strPicPath: require('../assets/images/banner1.jpg'),
          strMasTitle: '省政协十二届四次会议胜利闭幕'
        },
        {
          strPicPath: require('../assets/images/banner2.jpg'),
          strMasTitle: '建言献策 汇聚正能量——省政协十二届四次会议剪影'
        },
        {
          strPicPath: require('../assets/images/banner3.jpg'),
          strMasTitle: '参政议政 画好同心圆——省政协十二届四次会议剪影'
        },
        {
          strPicPath: require('../assets/images/banner4.jpg'),
          strMasTitle: '【两会直击】“委员通道”来了 你关心的问题都在这儿'
        }
      ]
    }
  },
  props: {},
  computed: {},
  created() {
    this.isSpecial =
      this.$route.query.strWebSiteId === 'b4a5ad6f2ad74fe6a2310d313bba36b7' ||
      this.$route.query.strWebSiteId === '4b4dc894e2894d4c966c03db2669de03'
    this.getInfoData() // 获取首页数据
    // this.getNavigationForZx(); // 获取友情链接数据
  },
  mounted() {},
  methods: {
    //获取首页数据
    // getInfoData() {
    //     infoData({ strWebSiteId: this.$store.state.strWebSiteId })
    //         .then((res) => {
    //             this.webPositionData = get(
    //                 ['data', 'webPositionData'],
    //                 res.data
    //             );
    //             document.title = get(['data', 'strName'], res.data);
    //         })
    //         .catch((err) => {
    //             this.$message.destroy();
    //             this.$message.error(err);
    //         });
    // },
    async getInfoData() {
      let that = this
      let strWebSiteId = this.$route.query.strWebSiteId
      homeData({
        strWebSiteId: strWebSiteId
      })
        .then((res) => {
          let data = get(['data'], res.data).webPositionData
          let spliceData = data.splice(0,6)
          spliceData.forEach(async (v, k) => {
            let curObj = spliceData[k]
            await bodyData({
              strColId: curObj.strColId,
              strColName: curObj.strColName,
              strType: curObj.strType,
              intCount: curObj.intCount
            })
              .then((res) => {
                const resData = get(['data'], res.data)
                this.webPositionData.push(resData)
                that.$set(
                  that.bodyContent,
                  'position' + (k),
                  get(['data'], res.data)
                )
              })
              .catch((err) => {
                that.$message.destroy()
                that.$message.error(err)
              })
          })
          that.getAllData(data)
        })
        .catch((err) => {
          this.$message.destroy()
          this.$message.error(err)
        })
        
    },
    getAllData(data) {
      const getrom = async (curObj) => {
        const data = await bodyData({
          strColId: curObj.strColId,
          strColName: curObj.strColName,
          strType: curObj.strType,
          intCount: curObj.intCount
        })
        return data.data.data
      }
      this.getPromiseData(data, getrom)
    },
    // getAllData() {
    //   let strWebSiteId = this.$route.query.strWebSiteId
    //   const getrom = async (curObj) => {
    //     const data = await bodyData({
    //       strColId: curObj.strColId,
    //       strColName: curObj.strColName,
    //       strType: curObj.strType,
    //       intCount: curObj.intCount
    //     })
    //     return data.data.data
    //   }
    //   homeData({
    //     strWebSiteId: strWebSiteId
    //   })
    //     .then((res) => {
    //       let data = get(['data'], res.data).webPositionData
    //     //   let dataLength = data.length
    //       for (let index = 0; index < 4; index++) {
    //            const spliceData = data.splice(0,1)
    //            console.log(getrom(spliceData));
    //            //this.getPromiseData(index,spliceData, getrom)
    //       }
    //     //   console.log(this.webPositionData);
    //       //console.log(data);
    //       //this.getPromiseData(data, getrom)
    //     //   const startData1 = data.splice(0,2)
    //     //   this.getPromiseData('startData1',startData1, getrom)
    //     //   const startData2 = data.splice(0,2)
    //     //   this.getPromiseData('startData2',startData2, getrom)
    //     //   this.getPromiseData(data, getrom)
    //     //   console.log(this.webPositionData);
    //       //   data.forEach((v, k) => {
    //       //     roomalls.push(getrom(v))
    //       //   })
    //       //   Promise.all(roomalls).then((res) => {
    //       //     this.webPositionData = res
    //       //     var end = new Date()
    //       //     var time = end - begin
    //       //     console.log(time)
    //       //   })
    //     })
    //     .catch((err) => {
    //       this.$message.destroy()
    //       this.$message.error(err)
    //     })
    // },
    getPromiseData(data, fun){
      let roomalls = []
      data.forEach((v, k) => {
        roomalls.push(fun(v))
      })
      Promise.all(roomalls).then((res) => {
       this.webPositionData.push(...res)
      })
    },
    //获取友情链接数据
    getNavigationForZx() {
      navigationForZx({ strWebSiteId: this.$store.state.strWebSiteId })
        .then((res) => {
          this.navigationForZxArr = get(['data'], res.data)
        })
        .catch((err) => {
          this.$message.destroy()
          this.$message.error(err)
        })
    },

    // 菜单跳转
    navHandle(strId) {
      this.$router.push({
        path: '/list',
        query: {
          strId: strId,
          strWebSiteId: this.$route.query.strWebSiteId
        }
      })
    },

    // 跳转详情
    detailHandle(strId) {
      let routeData = this.$router.resolve({
        path: '/detail',
        query: {
          strWebSiteId: this.$route.query.strWebSiteId,
          strId: strId
        }
      })
      window.open(routeData.href, '_blank')
    },

    // 友情链接
    linkHandle(item) {
      console.log(item)
      window.open(item.strUrl, '_blank') //跳转至新页面
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.home {
  background: url('../assets/images/bg.jpg') no-repeat center top;
  background-size: 100% auto;
  box-sizing: border-box;
  padding: 20px 0 0;
  .home-info {
    width: 1230px;
    margin: 0 auto;
  }
  .home-info-detail {
    width: 1230px;
    background-color: #fff;
    margin-left: -25px;
  }
  .container {
    width: 1230px;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 0 20px;
  }
  .slogan {
    h3 {
      font-weight: bold;
      font-size: 48px;
      line-height: 110px;
      color: #e20000;
      text-align: center;
      margin: 0 auto;
      cursor: pointer;
      &:hover {
        color: #1f5ac5;
      }
    }
    .row {
      p {
        font-size: 18px;
        color: #333;
        display: inline;
      }
      i {
        font-size: 18px;
        color: #bb2c1b;
        font-style: normal;
        cursor: pointer;
        &:hover {
          color: #1f5ac5;
        }
      }
    }
  }
  .list-swiper {
    display: flex;
    // align-items: center;
    margin: 35px auto 20px;
    .list {
      width: 450px;
      margin-right: 40px;
      ul {
        margin: 0;
        li {
          -webkit-line-clamp: 2;
          &:nth-child(1) {
            font-size: 24px;
            line-height: 32px;
            font-weight: bold;
            color: #e2201c;
            text-align: center;
            margin: 0 0 30px;
            border-bottom: 1px dashed #ccc;
            padding: 30px 0 35px;
            &::before {
              display: none;
            }
          }
        }
      }
    }
  }
  .schedule-work {
    display: flex;
    margin: 55px auto 20px;
    .work {
      width: 510px;
      margin-left: 20px;
      .title {
        text-align: right;
        background: url('../assets/images/work-bg.png') no-repeat center center;
        background-size: 100% auto;
        height: 58px;
        line-height: 58px;
        font-size: 16px;
        color: #333;
        box-sizing: border-box;
        padding: 0 10px 0 0;
        span {
          cursor: pointer;
          &:hover {
            color: #e2201c;
          }
        }
      }
      ul {
        li {
          &:nth-child(1) {
            font-size: 24px;
            line-height: 30px;
            color: #333;
            font-weight: bold;
            margin: 30px auto 20px;
            &::before {
              display: none;
            }
          }
        }
      }
    }
  }
  .statement-list {
    .title {
      display: block;
      width: 100%;
      height: auto;
      margin: 0 auto;
    }
    & > .row {
      display: flex;
      margin-top: 30px;
    }
    .list {
      width: 410px;
      margin-left: 30px;
      .item {
        margin-bottom: 30px;
        padding-bottom: 25px;
        border-bottom: 1px dashed #ccc;
        line-height: 24px;
        h5 {
          font-size: 24px;
          line-height: 32px;
          font-weight: bold;
          color: #e2201c;
          margin: 35px 0 20px 0;
        }
        .item-row {
          p {
            font-size: 16px;
            line-height: 24px;
            color: #555;
            display: inline;
            // text-overflow: -o-ellipsis-lastline;
            // overflow: hidden;
            // text-overflow: ellipsis;
            // display: -webkit-inline-box;
            // -webkit-line-clamp: 2;
            // -webkit-box-orient: vertical;
          }
          i {
            font-size: 18px;
            color: #bb2c1b;
            font-style: normal;
            cursor: pointer;
            &:hover {
              color: #1f5ac5;
            }
          }
        }
      }
      ul {
        margin: 0;
        li {
          &:nth-child(1) {
            padding: 0;
            overflow: visible;
            list-style: none;
            -webkit-line-clamp: initial;
            &::before {
              display: none;
            }
            p {
              margin: 0;
              line-height: 24px !important;
            }
            i {
              line-height: 24px !important;
            }
          }
        }
      }
    }
  }
  .list-wrap {
    ul {
      margin: 0;
      li {
        font-size: 18px;
        line-height: 40px;
        color: #333;
        position: relative;
        box-sizing: border-box;
        padding: 0 0 0 18px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        cursor: pointer;
        &:hover {
          color: red;
        }
        &::before {
          content: ' ';
          display: inline-block;
          position: absolute;
          left: 0;
          top: 17px;
          width: 8px;
          height: 8px;
          background-color: red;
          border-radius: 50px;
        }
      }
    }
  }
  .video-committee {
    display: flex;
    margin-top: 35px;
    .title {
      max-width: 100%;
      margin: 0 auto 30px;
    }
    .committee {
      width: 450px;
      margin-left: 80px;
      ul {
        li {
          line-height: 54px;
          &::before {
            top: 24px;
          }
        }
      }
    }
    .video {
      width: 655px;
    }
  }
  .report {
    .title {
      margin: 50px auto 30px;
    }
    ul {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0;
      li {
        width: 580px;
        height: 140px;
        position: relative;
        cursor: pointer;
        &:nth-child(1) {
          margin-right: 35px;
          background: url('../assets/images/report1.jpg') no-repeat center
            center;
          background-size: 100% 140px;
        }
        &:nth-child(2) {
          background: url('../assets/images/report2.jpg') no-repeat center
            center;
          background-size: 100% 140px;
        }
        p {
          position: absolute;
          top: 0;
          left: 125px;
          right: 0;
          text-align: center;
          line-height: 140px;
          font-size: 40px;
          color: #fff;
          font-weight: bold;
        }
      }
    }
  }
  .meeting-place {
    margin: 45px auto 80px;
    .title {
      max-width: 100%;
      margin: 0 auto 50px;
    }
    .row {
      display: flex;
      align-items: center;
      justify-content: space-around;
      .item {
        &:nth-child(2n + 1) {
          width: 372px;
          .info {
            height: 264px;
            position: relative;
            overflow: hidden;
            &:nth-child(1) {
              margin: 0 0 9px 0;
            }
          }
        }
        &:nth-child(2n) {
          width: 422px;
          margin: 0 12px;
          .info {
            height: 537px;
            position: relative;
            overflow: hidden;
          }
        }
        img {
          display: block;
          width: 100%;
          height: auto;
        }
        p {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 10;
          height: 45px;
          line-height: 45px;
          background: rgba(0, 0, 0, 0.6);
          display: block;
          text-align: center;
          font-size: 16px;
          color: #fff;
          margin: 0;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}
</style>
